/**
 * THIS FILE WILL WORK AS THE START UP FILE FOR THE APPLICATION
 * THIS WILL CONTAIN THE HEADER AND FOOTER AND COMMON ROUTE IMPORT
 */
import React from 'react';
import Header from 'Home/Header/Header';
import RoutesSetup from 'Home/Routes/Routes';
import Footer from 'Home/Footer/Footer';
import config from "./config";
import { Base64 } from 'js-base64';

class App extends React.Component{

    componentDidMount() {
        window.addEventListener("storage", this.handleStorageEvent);
    }

    componentWillUnmount() {
        window.removeEventListener("storage", this.handleStorageEvent);
    }


    handleStorageEvent = (event) => {
        function getCookie(name) {
            const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
            return match ? match[2] : null;
        }

        if (event.key === "logout-event") {
            // 🚪 Another tab logged out → reload this tab
            // backend (vmlogout.php) will handle redirect to login
            window.location.replace(`${config.RootUrl}/public/auth/#/login/${config.instructorInfo.InstituteUrl}`);
        }

        if (event.key === "token_update") {
            console.log("🔄 Token updated in another tab. Syncing cookies silently...");
            // Sync latest tokens/deviceId silently
            const userToken = getCookie("user_token_wc");
            const syncToken = getCookie("sync_token_wc");
            const userDetailsCookie = getCookie("user_details_wc");

            if (userToken && syncToken) {
                config.user_token = userToken;
                config.sync_token = syncToken;
            }

            if (userDetailsCookie) {
                try {
                    const firstDecode = Base64.decode(userDetailsCookie);
                    const secondDecode = Base64.decode(firstDecode);
                    const userDetails = JSON.parse(secondDecode);
                    config.deviceId = userDetails?.data?.DeviceId || config.deviceId;
                } catch (err) {
                    console.error("Error decoding user_details:", err);
                }
            }
        }

    };

    render() {

    
        return (
            <div className="App">
                
                <Header />
                
                <RoutesSetup />
                
                <Footer />

            </div>
        );
    }
}

export default App;
